export default __webpack_public_path__ + "static/media/icon-download.ab502036.svg";